import { useEffect } from "react";
import { initGA, initGTM, trackPageView, trackFormCompleted, trackFormAbandoned } from "../analytics/gtag";

export default function useIntakeAnalytics({
    gaMeasurementId = process.env.REACT_APP_GA_MEASUREMENT_ID,
    gtmContainerId = process.env.REACT_APP_GTM_CONTAINER_ID,
    isComplete,
    answersLength,
    formStartTime,
    totalVisibleQuestions,
}) {
    // Init GTM and GA
    useEffect(() => {
        if (gtmContainerId) {
            initGTM(gtmContainerId);
            // Send initial page_view event to GTM for Clarity
            trackPageView();
        }
        if (gaMeasurementId) initGA(gaMeasurementId);
    }, [gaMeasurementId, gtmContainerId]);

    // Before unload => abandonment
    useEffect(() => {
        const handleBeforeUnload = () => {
            if (answersLength > 0 && !isComplete) {
                trackFormAbandoned(answersLength, totalVisibleQuestions);
            }
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => window.removeEventListener("beforeunload", handleBeforeUnload);
    }, [answersLength, isComplete, totalVisibleQuestions]);

    // Completion event
    useEffect(() => {
        if (isComplete && answersLength > 0) {
            const completionTime = Math.round((Date.now() - formStartTime) / 1000);
            trackFormCompleted(answersLength, completionTime);
        }
    }, [isComplete, answersLength, formStartTime]);
}
